import { MenuItem, Typography } from '@mui/material'
import React from 'react'
import { NotificationModel } from 'src/Libs/notifications/models/notifications.model'
import { makeStyles } from 'tss-react/mui'
import NotificationTypeSymbol from '../NotificationTypeSymbol'

const useStyles = makeStyles()(theme => ({
  notifications: {
    display: 'flex',
    backgroundColor: theme.palette.shades.shade04,
    minHeight: '53px',
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.shades.shade03}`,
    borderRadius: theme.shape.borderRadius,
  },
}))

interface Props {
  notification: NotificationModel
  onClick: (notificationId: number) => void
}

/**
 * Displays a notification item preview
 */
const NotificationMenuItem: React.VFC<Props> = ({ notification, onClick }) => {
  const { classes } = useStyles()

  return (
    <MenuItem onClick={() => onClick(notification.id)} className={classes.notifications}>
      <NotificationTypeSymbol notificationType={notification.type} readAt={notification.readAt} />
      <Typography variant="inherit" noWrap>
        {notification.title}
      </Typography>
    </MenuItem>
  )
}

export default NotificationMenuItem
